export default "__VITE_ASSET__BGecjxQ6__"